// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__GUfij","active":"Content_active__23L2e"};